import * as z from "zod";
import { assertCanWriteChat } from "./chatAccess";
import { mutator } from "./mutator";

export const generateChatRecapSchema = z.object({
  chatId: z.string(),
  onDemand: z.boolean().optional(),
});

export const generateChatRecap = mutator({
  schema: generateChatRecapSchema,
  resolve: {},
  permissions: {
    none: "write access is checked in fn: the caller’s own personal chat, or a workflow chat in a space they can write",
  },
  fn: async ({ tx, ctx, args: { chatId } }) => {
    // Generating a recap writes to the chat, so it requires write access:
    // the user's own personal chat, or a workflow chat whose space they can
    // write. Read-only viewers can still see an already-generated recap.
    await assertCanWriteChat(tx, ctx, chatId);
  },
});
